import script from "./TableOfContents.vue?vue&type=script&setup=true&lang=js"
export * from "./TableOfContents.vue?vue&type=script&setup=true&lang=js"

import "./TableOfContents.vue?vue&type=style&index=0&id=2b8f109a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b8f109a"]])

export default __exports__